export default () => ({
  isLoading: false,
  cartIsLoading: false,
  productIsLoading: false,
  cartTotal: 0,
  qty: 1,
  cartIsOpen: false,
  /* cartItemsQuantity: 0,*/
  cartAllItemsQuantity: 0,
  generalItems: [],
  generalItemsQuantity: 0,
  lineItemQuantity: 0,
  inventoryQuantity: 0,
  currentProductVariantId: null,
  firstAvailableVariant: null,
  addToCartButtons: null,
  productPageWarningText: null,
  finalPricesArray: [],
  currencySymbol: null,
  currentProductAvailableQuantity: 0,
  thresholdProductId: null,
  thresholdAmount: null,
  mainProduct: null,
  giftReceived: false,
  body: null,
  cartItems: [],
  giftProduct: null,
  giftProductKey: null,
  freeShippingThreshold: null,
  giftProductDifference: 0,
  giftProductScaleWidth: 0,
  freeShippingDifference: 0,
  freeShippingScaleWidth: 0,
  init() {
    this.body = document.querySelector("body")
    this.finalPricesArray = JSON.parse(localStorage.getItem("finalPrice")) || []
    this.mainProduct = document.querySelector("[data-main-product]")

    this.thresholdProductId = this.body.getAttribute(
      "data-threshold-product-id"
    )
    this.thresholdAmount = this.body.getAttribute("data-threshold-amount")
    this.freeShippingThreshold = this.body.getAttribute(
      "data-free-shipping-threshold"
    )

    if (document.querySelector("[data-variants]")) {
      const variantsJSON = document.querySelector("[data-variants]").innerHTML
      if (variantsJSON) {
        this.firstAvailableVariant =
          JSON.parse(variantsJSON).firstAvailableVariant
      }
    }

    if (document.getElementById("MainContent")) {
      this.currencySymbol = document
        .getElementById("MainContent")
        .getAttribute("data-currency-symbol")
    }
    if (document.getElementById("main-product")) {
      this.inventoryQuantity = document
        .getElementById("main-product")
        .getAttribute("data-inventory")
      this.currentProductVariantId = document
        .getElementById("main-product")
        .getAttribute("data-variant-id")
      this.addToCartButtons = document.querySelectorAll('button[type="submit"]')
      this.productPageWarningText = document.querySelector(".max-qty__message")
    }
    this.getCardItems()

    const handleSWYMAddToCart = ()=>{
      const event = 'sw:addedtocart';
      const listener = (e) => {
        const data = e.detail.d.productData;
        this.addedFromWishlist = true
        this.getCardItems()
        fetch(window.location.pathname + '/?sections=ajax-cart')
          .then(res => res.json())
          .then(data=>{
            this.renderFromResponse(data["ajax-cart"])
          })
        this.openMiniCart()
      };
      _swat.evtLayer.addEventListener(event, listener);
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(handleSWYMAddToCart);
  },
  add(event, section) {
    this.productIsLoading = true
    let formData = ""
    let contentType = ""
    const form = event.currentTarget.closest("form")
    formData = new FormData(form)

    if (
      this.qty >= this.currentProductAvailableQuantity &&
      this.currentProductAvailableQuantity !== 0
    ) {
      this.qty = this.currentProductAvailableQuantity
      formData.set("quantity", this.qty)
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers:
        contentType !== ""
          ? {
              "Content-Type": contentType,
            }
          : {},
      body: formData,
    })
      .then((response) => {
        if (response.status === 200) {
          this.productIsLoading = false
          return response.json()
        }
        if (response.status === 422) {
          this.productIsLoading = false
          return response.json()
        }
      })
      .then((data) => {
        if (data && !data.status) {
          this.renderFromResponse(data.sections[section])
          this.getCardItems()
          this.openMiniCart()
        }
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  },
  remove() {
    this.isLoading = true
    alert("cart.remove")

    setTimeout(() => {
      this.isLoading = false
    }, 2000)
  },
  change(index, quantity, section, id) {
    this.cartIsLoading = true
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: { [index]: quantity },
        sections: section,
      }),
    })
      .then((res) => {
        if (res.status === 200) {
          this.cartIsLoading = false
          return res.json()
        }

        if (res.status === 422) {
          this.cartIsLoading = false
        }
      })
      .then((data) => {
        if (data) {
          this.cartAllItemsQuantity = data.item_count
          this.lineItemQuantity = data.quantity ? data.quantity : 0
          this.renderFromResponse(data.sections[section])
          this.getCardItems(id, quantity)
        }
        return data
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  },
  renderFromResponse(section) {
    const cartItemsMain = document.querySelector(".cart-inner__wrapper")
    const parsed = new DOMParser().parseFromString(section, "text/html")

    if (parsed.querySelector(".cart-inner__wrapper")) {
      const cartItemsWrapperHTML = parsed.querySelector(
        ".cart-inner__wrapper"
      ).innerHTML
      if (cartItemsWrapperHTML) {
        cartItemsMain.innerHTML = cartItemsWrapperHTML
      }
    }
  },
  openMiniCart() {
    this.cartIsOpen = true
  },
  closeMiniCart() {
    this.cartIsOpen = false
  },
  getCardItems(id = null, quantity) {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        this.cartAllItemsQuantity = data.item_count
        this.showHideFeaturedProductsOnCartPage()
        this.generalItemsQuantity = data.item_count
        this.generalItems = data.items
        this.cartTotal = data.total_price

        if (this.thresholdProductId && this.thresholdAmount) {
          this.checkGiftProduct(data)
          this.calculateGiftAmountDifference(this.cartTotal)
        }

        if (this.freeShippingThreshold && this.freeShippingThreshold > 0) {
          this.calculateFreeShippingDifference(this.cartTotal)
        }
      })
  },
  manipulateAmount(inputString, multiplier, symbol) {
    const initialAmount = parseFloat(inputString.replace(/[^\d.]/g, ""))
    if (isNaN(initialAmount)) {
      return "Invalid input format. Please provide a valid amount."
    }

    const result = initialAmount * multiplier

    return `${symbol}${result.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  },
  showHideFeaturedProductsOnCartPage() {
    const featuredProducts = document.querySelector(".collections-image-cards")

    if (featuredProducts) {
      if (this.cartAllItemsQuantity === 0) {
        featuredProducts.classList.remove("hidden")
      } else {
        featuredProducts.classList.add("hidden")
      }
    }
  },
  addGiftProduct() {
    if (this.thresholdProductId && this.thresholdAmount) {
      this.cartIsLoading = true
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: this.thresholdProductId,
          quantity: 1,
          sections: "ajax-cart",
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            this.cartIsLoading = false
            this.renderFromResponse(data.sections["ajax-cart"])
            fetch(window.Shopify.routes.root + "cart.js")
              .then((res) => res.json())
              .then((data) => {
                this.generalItems = data.items
                this.generalItemsQuantity = data.item_count
                this.cartTotal = data.total_price
                this.calculateGiftAmountDifference(this.cartTotal)
                this.calculateFreeShippingDifference(this.cartTotal)
              })
          }
        })
    }
  },
  removeGiftProduct(key) {
    this.cartIsLoading = true
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: { [key]: 0 },
        sections: "ajax-cart",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.cartIsLoading = false
        this.generalItems = data.items
        this.generalItemsQuantity = data.item_count

        this.renderFromResponse(data.sections["ajax-cart"])

        fetch(window.Shopify.routes.root + "cart.js")
          .then((res) => res.json())
          .then((data) => {
            this.generalItems = data.items
            this.generalItemsQuantity = data.item_count
            this.cartTotal = data.total_price
            this.calculateGiftAmountDifference(this.cartTotal)
            this.calculateFreeShippingDifference(this.cartTotal)
          })
      })
  },
  checkGiftProduct(data) {
    const cartTotalAmount = data.total_price

    this.giftProduct = this.generalItems
      ? this.generalItems.find((item) => item.id == this.thresholdProductId)
      : null

    if (this.giftProduct) {
      this.giftProductKey = this.giftProduct.key
    }

    if (this.cartTotal >= this.thresholdAmount * 100 && !this.giftProduct) {
      this.addGiftProduct()
    } else if (
      this.cartTotal >= this.thresholdAmount * 100 &&
      this.giftProduct &&
      this.giftProduct.final_line_price !== 0 &&
      this.generalItems.length > 1
    ) {
      this.removeGiftProduct(this.giftProductKey)
    } else if (
      this.cartTotal < this.thresholdAmount * 100 &&
      this.giftProduct &&
      this.generalItems.length > 1
    ) {
      this.removeGiftProduct(this.giftProductKey)
    } else if (
      this.cartTotal < this.thresholdAmount * 100 &&
      this.giftProduct &&
      this.generalItems.length === 1
    ) {
      this.removeGiftProduct(this.giftProductKey)
    }
  },
  calculateGiftAmountDifference(totalAmount) {
    this.giftProductDifference =
      (this.thresholdAmount * 100 - totalAmount) / 100

    if (this.giftProductDifference > 0) {
      this.giftProductScaleWidth =
        100 - (this.giftProductDifference * 100) / this.thresholdAmount
    } else {
      this.giftProductDifference = 0
      this.giftProductScaleWidth = 100
    }
  },
  calculateFreeShippingDifference(totalAmount) {
    this.freeShippingDifference =
      (this.freeShippingThreshold * 100 - totalAmount) / 100

    if (this.freeShippingDifference > 0) {
      this.freeShippingScaleWidth =
        100 - (this.freeShippingDifference * 100) / this.freeShippingThreshold
    } else {
      this.freeShippingDifference = 0
      this.freeShippingScaleWidth = 100
    }
  },
})